import { c as _c } from "react/compiler-runtime";
import { doesColumnPassAnyFilter, doesEntityPassQuickFilter } from "@hooks/table-filters/use-apply-filter-utils";
import { useFilterQueryParams } from "@hooks/table-filters/use-filter-query-params";
import { useMemo } from "react";
/** Apply all the filters to the entities and return the ones that pass */
export function useApplyFilters(t0) {
  const $ = _c(15);
  const {
    entities,
    allTableFilters,
    requiredColumns,
    quickFilterEntity
  } = t0;
  const {
    quickFilter,
    isAnyFilterApplied,
    getFilterIdsForColumn
  } = useFilterQueryParams();
  let t1;
  bb0: {
    if (quickFilter === "" && !isAnyFilterApplied) {
      t1 = entities;
      break bb0;
    }
    let t2;
    if ($[0] !== allTableFilters || $[1] !== entities || $[2] !== getFilterIdsForColumn || $[3] !== isAnyFilterApplied || $[4] !== quickFilter || $[5] !== quickFilterEntity || $[6] !== requiredColumns) {
      let t3;
      if ($[8] !== allTableFilters || $[9] !== getFilterIdsForColumn || $[10] !== isAnyFilterApplied || $[11] !== quickFilter || $[12] !== quickFilterEntity || $[13] !== requiredColumns) {
        t3 = entity => {
          if (!doesEntityPassQuickFilter({
            quickFilter,
            quickFilterEntity: quickFilterEntity(entity, quickFilter)
          })) {
            return false;
          }
          if (!isAnyFilterApplied) {
            return true;
          }
          return requiredColumns.every(column => {
            const allPossibleFiltersForColumn = allTableFilters[column];
            if (getFilterIdsForColumn(column).length === 0 || allPossibleFiltersForColumn === undefined) {
              return true;
            }
            return doesColumnPassAnyFilter({
              entity,
              activeFilterIds: getFilterIdsForColumn(column),
              allPossibleFiltersForColumn
            });
          });
        };
        $[8] = allTableFilters;
        $[9] = getFilterIdsForColumn;
        $[10] = isAnyFilterApplied;
        $[11] = quickFilter;
        $[12] = quickFilterEntity;
        $[13] = requiredColumns;
        $[14] = t3;
      } else {
        t3 = $[14];
      }
      t2 = entities.filter(t3);
      $[0] = allTableFilters;
      $[1] = entities;
      $[2] = getFilterIdsForColumn;
      $[3] = isAnyFilterApplied;
      $[4] = quickFilter;
      $[5] = quickFilterEntity;
      $[6] = requiredColumns;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    t1 = t2;
  }
  const filteredEntities = t1;
  return filteredEntities;
}